import Swal from 'sweetalert2';
import {Injectable} from '@angular/core';
import {I18nPipe} from '../../../services/i18n.pipe';

@Injectable({
  providedIn: 'root'
})
export class SweetUtil {

  constructor(private i18nPipe: I18nPipe) {
  }

  static showSuccess(text: string) {
    return Swal.fire({
        title: 'Completed',
        html: text,
        icon: 'success',
        customClass: {confirmButton: 'swal'}
      }
    );
  }

  static showSuccessWithTitle(title: string, text: string) {
    return Swal.fire({
        title,
        html: text,
        icon: 'success',
        showConfirmButton: false,
        timer: 2000
      }
    );
  }

  static showWarning(text: string) {
    return Swal.fire({
        title: 'Warning',
        html: text,
        icon: 'warning',
        customClass: {confirmButton: 'swal'}
      }
    );
  }

  static showInfo(text: string) {
    return Swal.fire({
        title: 'Information',
        html: text,
        icon: 'info',
        customClass: {confirmButton: 'swal'}
      }
    );
  }

  static showInputDialog(titleWording: string, amountWording) {
    return Swal.fire({
      title: titleWording,
      input: 'number',
      showCancelButton: true,
      inputPlaceholder: amountWording,
      customClass: {confirmButton: 'swal', cancelButton: 'swal'}
    });
  }

  static showRefundCommentDialog(titleWording: string, comments: string) {
    return Swal.fire({
      title: titleWording,
      input: 'textarea',
      showCancelButton: true,
      inputPlaceholder: comments,
      customClass: {confirmButton: 'swal', cancelButton: 'swal'}
    });
  }


  static getConfirm(title: string, text: string, confirmButtonText?: string, cancelButtonText?: string) {
    return Swal.fire({
      title,
      html: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButtonText || 'Yes',
      cancelButtonText: cancelButtonText || 'Cancel',
      customClass: {confirmButton: 'swal', cancelButton: 'swal'}
    });
  }

  showInfoTitleTranslated(text: string) {
    return Swal.fire({
        title: this.i18nPipe.transform('', 'information'),
        html: text,
        icon: 'info',
        confirmButtonText: this.i18nPipe.transform('', 'ok'),
        customClass: {confirmButton: 'swal'}
      }
    );
  }

  showError(text: string, errorTitle = 'error') {
    return Swal.fire({
        title: this.i18nPipe.transform('', errorTitle),
        text: this.i18nPipe.transform('', text),
        icon: 'error',
        confirmButtonText: this.i18nPipe.transform('', 'ok'),
        customClass: {confirmButton: 'swal'}
      }
    );
  }
  showInfoTranslated(text: string) {
    return Swal.fire({
        title: this.i18nPipe.transform('', 'information'),
        text: this.i18nPipe.transform('', text),
        icon: 'info',
        confirmButtonText: this.i18nPipe.transform('', 'ok'),
        customClass: {confirmButton: 'swal'}
      }
    );
  }

  getConfirmTranslated(title: string, text: string, confirmBtnText = 'yes', cancelBtnText = 'cancel') {
    return Swal.fire({
      title: this.i18nPipe.transform('', title),
      html: this.i18nPipe.transform('', text),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.i18nPipe.transform('', confirmBtnText),
      cancelButtonText: this.i18nPipe.transform('', cancelBtnText),
      customClass: {confirmButton: 'swal', cancelButton: 'swal'}
    });
  }

  showSuccessTranslated(title: string, text: string) {
    return Swal.fire({
      title: this.i18nPipe.transform('', title),
      html: this.i18nPipe.transform('', text),
      icon: 'success',
      confirmButtonText: this.i18nPipe.transform('', 'ok'),
      customClass: {confirmButton: 'swal'}
    });
  }

}
